import React from "react";
import { styled, ToggleButton } from "@mui/material";
import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";
import { Priority } from "@services/common/types";

const applyColor = (color: string) => ({
  backgroundColor: color,
  "&:hover": {
    backgroundColor: color,
  },
  "&.Mui-selected": {
    backgroundColor: color,
    "&:hover": {
      backgroundColor: color,
    },
  },
});
const Base = styled(ToggleButton)(({ theme }) => ({
  fontSize: getCurrentSizeProfile().small,
  ...responsiveFontSize(theme, "small"),
  height: "2em",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: "transparent",
  padding: theme.spacing(7 / 8),
  "&:not(:last-of-type)": {
    borderRadius: "12px",
  },
  "&:last-of-type": {
    borderRadius: "12px",
  },
  "&:hover": {
    opacity: 0.7,
  },
  "&.Mui-selected": {
    borderColor: theme.palette.common.white,
    "&:hover": {
      opacity: 0.7,
    },
  },
}));

export const Critical = styled(Base)(({ theme }) =>
  applyColor(theme.palette.ticket.Critical.main)
);
export const Major = styled(Base)(({ theme }) =>
  applyColor(theme.palette.ticket.Major.main)
);
export const Minor = styled(Base)(({ theme }) =>
  applyColor(theme.palette.ticket.Minor.main)
);
export const Informational = styled(Base)(({ theme }) =>
  applyColor(theme.palette.ticket.Informational.main)
);

const TicketPriority: { [k in Priority]: typeof Base } & {
  [k in TicketsPriorityFilter]: typeof Base;
} = {
  Critical,
  Major,
  Minor,
  Informational,
};

export default TicketPriority;
